// ISO "YYYY-MM-DD" <-> Date for the date facets (FacetsPanel's DateRangeRow, SearchMask's "Planbar
// ab"). Mantine's DatePickerInput hands out LOCAL-midnight Dates (and expects them back), while the
// engine compares plain ISO strings (engine.applyFilters) - so the conversion has to read and write
// the LOCAL calendar day. Going through toISOString()/new Date(iso) instead (both UTC) shifted the
// day by one on either side of UTC: a pick of 09.09. in Vienna became "2026-09-08" and redisplayed
// as 08.09. (reproduced under TZ=Europe/Vienna and TZ=America/New_York).

const pad2 = (n: number) => String(n).padStart(2, '0');

export const isoToDate = (iso?: string): Date | null => {
    if (!iso) {
        return null;
    }
    const [year, month, day] = iso.split('-').map(Number);
    return Number.isFinite(year) && Number.isFinite(month) && Number.isFinite(day)
        ? new Date(year, month - 1, day)
        : null;
};

export const dateToIso = (date: Date | null): string | undefined =>
    date ? `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}` : undefined;
